<template>
  <div class="event-result-list-item">
    <div class="event-result-list-item__inner">
      <div class="event-result-list-item__media-date-wrap">
        <div class="event-result-list-item__date">
          <span class="event-result-list-item__date--day">{{
            formatDate(event.date.start.date, "DD")
          }}</span>
          <span class="event-result-list-item__date--month">{{
            formatDate(event.date.start.date, "MMM")
          }}</span>
        </div>
        <div
          v-if="event.image.image_sizes"
          class="event-result-list-item__media"
        >
          <img v-lazy="event.image.image_sizes.large" :alt="event.summary" />
        </div>
        <div v-else class="event-result-list-item__media">
          <img
            src="/themes/custom/idfive_accelerator/idfive-component-library/public/images/placeholders/event-placeholder.png"
            :alt="event.summary"
          />
        </div>
      </div>
      <div class="event-result-list-item__content">
        <div class="event-result-list-item__time">
          <div v-if="event.date.all_day === '1'">All Day</div>
          <div v-else>
            {{ event.date.start.time }}
          </div>
        </div>
        <h2 class="event-result-list-item__title">
          <a
            class="event-result-list-item__title-link"
            :href="getPath(event.url)"
            >{{ event.title }}</a
          >
        </h2>
        <div class="event-result-list-item__summary">
          <p v-html="event.summary"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import MiniCalenderEventSocial from './mini-calendar-event-social.vue'
import moment from "moment";
import { mapGetters } from "vuex";
import { BASE_URL } from "@/utils/config";

export default {
  name: "MiniCalenderEvent",
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["date_range"]),
  },
  methods: {
    getPath(url) {
      return BASE_URL + url;
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    checkInDate(start_date) {
      const currentDate = moment();
      if (!this.date_range || !this.date_range.end) {
        return moment(start_date).isSameOrAfter(currentDate);
      }
      const endDate = moment(this.date_range.end);
      return (
        moment(start_date).isSameOrAfter(currentDate) &&
        moment(start_date).isSameOrBefore(endDate)
      );
    },
  },
};
</script>
